export const quotation = state => state.quotation
export const sidebar = state => state.app.sidebar
export const layoutGrid = state => state.app.layoutGrid // 用于yunji-components AttractFooter 组件左侧宽度计算
